import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/tickets-statuses')({
  beforeLoad: () => getTitleContextSlice('Ticket Statuses'),
  staticData: {
    owner: CodeOwner.Uvm,
  },
});
